import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styled from "styled-components";

import { Select } from "components/atoms/Select";
import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const StyledAccordionContainer = styled.div`
    width: 100%;
    padding: 0 1rem;
`;

export const StyledAccordion = styled(Accordion)`
    width: 100%;
    background-color: ${colourScheme.primary} !important;
    color: ${colourScheme.white} !important;
    margin-bottom: 1rem;
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
    background-color: ${colourScheme.primaryLight} !important;
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    ${device.md} {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 1rem;
    }
`;

export const FormControl = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 1.25rem;
    flex: 1 1 20%;
`;

export const MenuItem = styled.option`
    font-size: 1rem;
    padding: 0.625rem;
`;

export const SortFilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    margin-bottom: 1.25rem;
`;

export const LabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-right: 1rem;
    align-items: flex-start;

    ${device.md} {
        flex-direction: row;
        align-items: center;
    }
`;

export const AccordionTitle = styled.div`
    font-weight: bold;
    text-transform: uppercase;
    flex-grow: 1;
`;

export const SearchSelect = styled(Select)`
    padding: 0.625rem;
    min-width: 5rem;
`;

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
`;
